module.exports = __webpack_public_path__ + "static/media/noimage.da0c9c3d.jpg";